export default "__VITE_ASSET__C2fm3XlW__"